import React, { useState } from 'react';
import FiyatTablosu from '../components/fiyat_tablo';
import TradingView from '../components/tradingview';
import Mob from '../components/mob';
import AraHakkimizda from '../components/ara_hakkimizda';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/HomePage.css';

const HomePage = () => {
  const { isDarkMode } = useTheme();
  const [selectedSymbol, setSelectedSymbol] = useState('GAUTRY');

  // Parite seçimi için handler
  const handleSymbolSelect = (symbol) => {
    setSelectedSymbol(symbol);
  };

  return (
    <div className={`home-page ${isDarkMode ? 'dark-mode' : ''}`}>
      {/* Info Banner */}
      <section className="info-banner">
        <div className="container">
          <div className="banner-content">
            <span>Fiyatlarımız bilgi amaçlıdır.</span>
          </div>
        </div>
      </section>
      
      <FiyatTablosu onSymbolSelect={handleSymbolSelect} />
      
      {/* TradingView Grafik */}
      <section className="tradingview-section">
        <div className="container">
          <TradingView selectedSymbol={selectedSymbol} />
        </div>
      </section>
      
      {/* Mobil Uygulama Bölümü */}
      <Mob />
      
      <AraHakkimizda />
    </div>
  );
};

export default HomePage;
